import React from 'react';
import Recommended from '../data/Recommended';
import SocialLinks from '../data/SocialLinks';
import ResponsiveCarousel from "./ResponsiveCarousel";


function Footer() {
    const year = new Date().getFullYear();
    const scrollTop = () => document.getElementById('top').scrollIntoView({ behavior: 'smooth' });

    const slides = Recommended.map(link => ({
        src: link.ImageUrl,
        alt: link.Title,
        url: link.Url,
        caption: link.Title
    }));

    return (<>
        <footer>
            <div className="text-center">
                <div id="footer-social-links" className="col-12 mt-3">
                    <ul className="list-inline">
                        {SocialLinks.map(link =>
                            <li key={link.Title} className="list-inline-item">
                                <a className="icon fs-2" href={link.Url} rel="nofollow" target="_blank" title={`Follow on ${link.Title}`}>
                                    <span className={`icon-${link.Title.toLowerCase()}`}></span>
                                    <span className="visually-hidden">Follow on {link.Title}</span>
                                </a>
                            </li>
                        )}
                    </ul>
                </div>
                <h2 className="font-semibold">Recommended</h2>
                <div style={{ maxWidth: 1100, margin: "0 auto", padding: 20 }}>
                    <ResponsiveCarousel items={slides} autoplay={true} interval={5000} breakpoints={{ 0: 1, 800: 2, 1200: 3 }} />
                </div>
                <div className="mt-3 mb-3">© Bitmigo 2016 - {year}</div>
            </div>
        </footer>
        <button className="btn btn-secondary" type="button" id="scroll-top" onClick={scrollTop}><span className="visually-hidden">top</span><span className="icon-up-open"></span></button>
        </>
    );

}export default Footer